export default __webpack_public_path__ + "ed0a2984b27b616e94dd4a09cb5ec5d9.svg";